export function buildLineTableData({
  line,
  perfisDisponiveis,
  kmTotalRota,
  turnoNome,
}) {

    return {
        Cliente: line.GRUPO ?? '',
        'Código de Integração':
            line.CODIGO_INTEGRACAO,
        Linha: `${line.NOMELINHA} - ${line.PREFIXO}`,
        Turno: turnoNome,
        Sentido: line.SENTIDO === 0
            ? 'Entrada'
            : 'Retorno',
        'Unidade Operacional':
            perfisDisponiveis.find(
            p => p.id === line.unidade_opera
            )?.nome ?? '',
        'KM Previsto': kmTotalRota,
    };

}